<template>
    <div id="header">
        <div class="btn-back">
            <font-awesome-icon icon="dove" />
        </div>
        <div class="title">
            {{ title }}
        </div>
        <div class="menu" @click="login()">{{nick == null ? '登录' : nick}}</div>
    </div>
</template>

<style lang="less">
@header-height: 50px;
#header {
    height: @header-height;
    display: flex;
    flex-direction: row;
    background-color: #f8f8f8;
    .btn-back {
        display: flex;
        align-items: center;
        padding-left: 16px;
    }
    .title {
        flex-grow: 1;
        display: flex;
        align-items: center;
        padding: 0 16px;
        font-size: 20px;
        font-weight: bold;
    }
    .menu {
        width: @header-height;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 16px;
    }
}
</style>

<script>
import {url_for} from '../lib/util'
import axios from 'axios'

export default {
    data() {
        return {
            loading: true,
            logined: false,
            nick: null
        }
    },
    props: {
        title: {
            type: String,
            default: "Fling",
        },
    },
    created() {
        axios.get('/pwa/user').then((resp) => {
            var data = resp.data
            if(data['nick'] !== undefined) {
                this.nick = data['nick']
                this.logined = true
            } else {
                this.logined = false
            }
        }).catch((err) => {
            this.logined = false
            alert(err)
        }).finally(() => {
            this.loading = false
        })
    },
    methods: {
        login() {
            if(this.loading) {
                return
            }
            if(this.logined) {
                return
            }
            this.route('login')
        },
        route(uri) {
            location.href = url_for(uri)
        }
    }
};
</script>
